import { __rest } from "tslib";
import React, { useEffect } from "react";
import { TimeSelect } from "./TimeSelect";
import { getValidTimeValue, genShowHourMinuteSecond, getHourMinuteSecond, getDisabledHours, getDisabledMinutes, getDisabledSeconds, getDisabledMilliseconds, } from "./util";
export function Combobox(_a) {
    var _value = _a.value, onChange = _a.onChange, _b = _a.format, format = _b === void 0 ? "HH:mm:ss" : _b, props = __rest(_a, ["value", "onChange", "format"]);
    var value = getValidTimeValue(_value, props, format);
    // 传入的时间可能不在限定范围内，此时需要同步时间
    useEffect(function () {
        if (_value && !_value.isSame(value))
            onChange(value, { event: null });
    }, [_value, onChange, value]);
    var _c = genShowHourMinuteSecond(format), showHour = _c.showHour, showMinute = _c.showMinute, showSecond = _c.showSecond, showMilliseconds = _c.showMilliseconds;
    var _d = _value ? getHourMinuteSecond(value) : {}, _e = _d.hour, hour = _e === void 0 ? null : _e, _f = _d.minute, minute = _f === void 0 ? null : _f, _g = _d.second, second = _g === void 0 ? null : _g, _h = _d.milliseconds, milliseconds = _h === void 0 ? null : _h;
    var handleItemChange = function (type) { return function (selectValue, context) {
        var newValue = value.clone();
        switch (type) {
            case "hour":
                newValue.hour(selectValue);
                break;
            case "minute":
                newValue.minute(selectValue);
                break;
            case "second":
                newValue.second(selectValue);
                break;
            case "milliseconds":
                newValue.milliseconds(selectValue);
                break;
        }
        onChange(getValidTimeValue(newValue, props, format), context);
    }; };
    var _j = props.hourStep, hourStep = _j === void 0 ? 1 : _j, _k = props.minuteStep, minuteStep = _k === void 0 ? 1 : _k, _l = props.secondStep, secondStep = _l === void 0 ? 1 : _l, _m = props.millisecondsStep, millisecondsStep = _m === void 0 ? 1 : _m;
    return (React.createElement(React.Fragment, null,
        showHour && (React.createElement(TimeSelect, { value: hour, to: 23, step: hourStep, disabledValues: getDisabledHours(props), onChange: handleItemChange("hour") })),
        showMinute && (React.createElement(TimeSelect, { value: minute, to: 59, step: minuteStep, disabledValues: getDisabledMinutes(hour, props), onChange: handleItemChange("minute") })),
        showSecond && (React.createElement(TimeSelect, { value: second, to: 59, step: secondStep, disabledValues: getDisabledSeconds(hour, minute, props), onChange: handleItemChange("second") })),
        showMilliseconds && (React.createElement(TimeSelect, { value: milliseconds, to: 999, step: millisecondsStep, disabledValues: getDisabledMilliseconds(hour, minute, second, props), onChange: handleItemChange("milliseconds") }))));
}
Combobox.displayName = "TimePickerCombobox";
//# sourceMappingURL=TimeCombobox.js.map